import project1 from "../img/Featured Projects/project1.png";
import project2 from "../img/Featured Projects/project2.png";
import project3 from "../img/Featured Projects/project3.png";
import project4 from "../img/Featured Projects/project4.png";
import project5 from "../img/Featured Projects/project5.png";
import project6 from "../img/Featured Projects/project6.png";
import project7 from "../img/Featured Projects/project7.png";
import project8 from "../img/Featured Projects/project8.png";
import project9 from "../img/Featured Projects/project9.png";

const works = [
  {
    id: 1,
    src: [project1],
    desc:
      "Delivers services like Complete House Building, office Building, Interiors, etc..",
    title: "MNR Constructions",
    date: "March 20, 2020",
    category: "Mobile Application",
  },
  {
    id: 2,
    src: [project2],
    desc:
      "Online educational platform that provides Notes for university Coures.",
    title: "Gradex",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
  {
    id: 3,
    src: [project3],
    desc:
      "Scrumble gives you a powerful way to showcase your project ,skills s case studies, and get descovered as a creative professional.",
    title: "Scrumbble",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
  {
    id: 4,
    src: [project4],
    desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut ligula leo. Aliquam suscipit sed purus. Ipsum dolor sit amet, consectetur adipiscing elit.",
    title: "Utkalhacks",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
  {
    id: 5,
    src: [project5],
    desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut ligula leo. Aliquam suscipit sed purus. Ipsum dolor sit amet, consectetur adipiscing elit.",
    title: "Utkal care",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
  {
    id: 6,
    src: [project6],
    desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut ligula leo. Aliquam suscipit sed purus. Ipsum dolor sit amet, consectetur adipiscing elit.",
    title: "Sharptutor",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
  {
    id: 7,
    src: [project7],
    desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut ligula leo. Aliquam suscipit sed purus. Ipsum dolor sit amet, consectetur adipiscing elit.",
    title: "Emisha",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
  {
    id: 8,
    src: [project8],
    desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut ligula leo. Aliquam suscipit sed purus. Ipsum dolor sit amet, consectetur adipiscing elit.",
    title: "Fleetchex",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
  {
    id: 9,
    src: [project9],
    desc: "Smart Attendance and School Management Android Application.",
    title: "Bellsoft",
    date: "July 12, 2019",
    category: "Mobile Application",
  },
];

export default works;
